import { memo, useMemo } from 'react';
import config from 'config';
import { defaultBasketData, ROUTES, ShoppingCartIcon } from 'constant';
import { useRouter } from 'next/navigation';
import { useGetShoppingCartQuery } from 'services/shoppingCartApi';

import { Box, Circle, IconButton, useTheme } from '@chakra-ui/react';

import { useAppDispatch } from 'store/hooks';
import { toggleCartBasket } from 'store/reducers/productsSlice';

import { sortShopList } from 'utils';

import { ShopCartItem, ShoppingCartName } from 'types';

import { Text } from 'ui';

const {
  header: { shoppingCartType },
  shop: { isCommerceAvailable }
} = config;

const Icon = ShoppingCartIcon[shoppingCartType as ShoppingCartName];

interface CartProps {
  isLogged: boolean;
  localItemStoreLength: number;
}

const Cart = ({ isLogged, localItemStoreLength }: CartProps) => {
  const dispatch = useAppDispatch();
  const {
    colors: {
      palette: {
        components: { headerColor }
      }
    }
  } = useTheme();
  const router = useRouter();

  const { data = defaultBasketData } = useGetShoppingCartQuery('', {
    skip: !isLogged
  });

  const sortedData: ShopCartItem[] = useMemo(
    () => sortShopList(data.items),
    [data]
  );

  const storeLength = isLogged ? sortedData.length : localItemStoreLength;
  const cartItemNumber = storeLength > 99 ? 99 : storeLength;

  const toCart = () => dispatch(toggleCartBasket());
  const toPackages = () => router.push(ROUTES.packagesShop);

  return (
    <IconButton
      aria-label='basket'
      onClick={isCommerceAvailable ? toCart : toPackages}
      variant='link'
      fontWeight={400}
      _hover={{
        textDecor: 'none'
      }}
      position='relative'
    >
      <Box>
        <Icon width={21} height={21} fill={headerColor.primaryColor} />
        <Circle
          position='absolute'
          display={cartItemNumber > 0 ? 'block' : 'none'}
          size='20px'
          bg={headerColor.badgeBg}
          color='white'
          top={-2}
          right={-1}
          pb={0.5}
        >
          <Text
            mt='1px'
            fontSize={12}
            fontFamily='main'
            color={headerColor.badgeColor}
          >
            {cartItemNumber}
          </Text>
        </Circle>
      </Box>
    </IconButton>
  );
};

export default memo(Cart);
